export const filterByLang = (voices, arrLang) => {
  if (arrLang.length === 0) {
    return voices
  }
  return voices.filter(voice => arrLang.includes(voice.language))
}

export const filterByParams = (voices, arrLang, arrGender, arrAge) => {
  let filteredVoices = filterByLang(voices, arrLang)

  if (arrGender.length !== 0) {
    filteredVoices = filteredVoices.filter(voice => arrGender.includes(voice.gender))
	}
	
	if(arrAge.length !== 0) {
		filteredVoices = filteredVoices.filter(voice => arrAge.includes(voice.age))
	}
	return filteredVoices
}
